module.exports = __webpack_public_path__ + "static/media/CircularStdBold.1ced22ee.woff";